module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_10-bb7585364211eedbcefd9aaae13aad69.png";